// extracted by mini-css-extract-plugin
export var closeButton = "_g0-2";
export var closeButtonIcon = "_g0-3";
export var lightboxContent = "_g0-1";
export var lightboxOverlay = "_g0-0";